const ListLoading = () => {
  return (
    <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md shadow-[0_0_50px_rgba(82,63,105,0.15)] bg-white text-gray-500 font-medium px-8 py-4 text-center'>
      Processing...
    </div>
  )
}

export {ListLoading}
